import { api } from "./axios";

export interface UpstreamInput {
  name?: string;
  endpoint?: string;
  public_key?: string;
  preshared_key?: string;
  client_private_key?: string;
  client_address?: string;
  awg_jc?: number;
  awg_jmin?: number;
  awg_jmax?: number;
  awg_s1?: number;
  awg_s2?: number;
  awg_h1?: number;
  awg_h2?: number;
  awg_h3?: number;
  awg_h4?: number;
  country?: string;
  city?: string;
}

export interface SingleCheckResult {
  upstream_id: number;
  name: string;
  success: boolean;
  latency_ms: number | null;
  fail_count: number;
  is_active: boolean;
}

export interface SuccessResponse {
  success: boolean;
  error?: string;
}

export const createUpstream = (input: UpstreamInput) =>
  api.post<SuccessResponse & { id?: number }>("/api/admin/upstreams", input);

export const updateUpstream = (id: number, input: UpstreamInput) =>
  api.put<SuccessResponse>(`/api/admin/upstreams/${id}`, input);

export const toggleUpstream = (id: number) =>
  api.post<SuccessResponse & { is_active?: boolean }>(
    `/api/admin/upstreams/${id}/toggle`
  );

export const reapplyUpstream = (id: number) =>
  api.post<SuccessResponse>(`/api/admin/upstreams/${id}/reapply`);

export const deleteUpstream = (id: number) =>
  api.delete<SuccessResponse>(`/api/admin/upstreams/${id}`);

export const checkUpstream = (id: number) =>
  api.post<SuccessResponse & { result?: SingleCheckResult }>(
    "/api/admin/upstreams/check",
    { id }
  );
